/** Uploaded documents: a PDF, or a photo or scan of one (the API checks the bytes, not the name). */
export const DOCUMENT_TYPES = 'application/pdf,image/jpeg,image/png,image/webp';
export const DOCUMENT_MAX_MB = 10;
export const DOCUMENT_HINT = `PDF, or a photo or scan (JPEG, PNG, WebP), up to ${DOCUMENT_MAX_MB} MB`;

export const documentProblem = (file: File | null, required = false) =>
  !file ? (required ? 'Choose the PDF or scan to upload.' : null) : file.size > DOCUMENT_MAX_MB * 1024 * 1024 ? `This file is ${(file.size / 1024 / 1024).toFixed(1)} MB. The limit is ${DOCUMENT_MAX_MB} MB.` : null;

/** A person's scans, as the API names them (services/person-documents.ts). */
export const PERSON_DOCUMENTS = [
  { kind: 'national_id', label: 'KTP' },
  { kind: 'family_card', label: 'Family card (KK)' },
  { kind: 'npwp', label: 'NPWP card' },
  { kind: 'bpjs_employment', label: 'BPJS Ketenagakerjaan card' },
  { kind: 'bpjs_health', label: 'BPJS Kesehatan card' },
  { kind: 'bank_book', label: 'Bank book' },
] as const;
export type PersonDocumentKind = (typeof PERSON_DOCUMENTS)[number]['kind'];
